import React from 'react';

// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export default function MarkAsFinishedModal({active, onAdd, onClose}) {

  return (
      <Dialog open={active} onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Send order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please, confirm you want to label this order as finished.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={e=>onAdd()} color="primary">
            Yes, I'm done!
          </Button>
        </DialogActions>
      </Dialog>
    )
}